<template>
  <b-row>
    <b-col cols="12" sm="12">
      <b-card class="mx-auto" tile>
          <InputBuscar :filter="filter" @input="filter = $event">
            <BotonAgregar 
              @mostrarModalAgregar="mostrarModalAgregarMarca" 
              :textoBoton="$t('vMarca.agregarMarca')"
              :iconBoton="iconBoton"/>
          </InputBuscar>
        <b-row>
          <div class="col-md-12">
            <BaseTable
              tableClass="mb3 tblmarcas tabla-marcas"
              :items="marcas"
              :fields="headers"
              :currentPage="currentPage"
              :perPage="perPage"
              :filter="filter"
              @filtered="onFiltered"
              :total-rows="totalRows">
              <template #cell(Acciones)="data">
                <div class="d-flex justify-content-start align-items-center">
                  <div class="p-1" v-if="data.item.id != marca.id">
                    <b-form-checkbox
                      switch
                      size="sm"
                      v-model="data.item.habilitado"
                      :set="(titulo = hoverHabilitado(data.item))"
                      @click.native="mostrarDialog(data.item)"
                      v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1" v-if="data.item.id == marca.id">
                    <b-form-checkbox
                      switch
                      size="sm"
                      v-model="data.item.habilitado"
                      :disabled="true"
                      :set="(titulo = hoverHabilitado(data.item))"
                      v-b-tooltip.hover="hoverHabilitado(data.item.habilitado)">
                    </b-form-checkbox>
                  </div>
                  <div class="p-1">
                    <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                      @click="mostrarModalEditar(data.item)"
                      v-b-tooltip.hover
                      :title="$t('Gral.editar')">
                      <feather type="edit" class="feather-sm mr-2"></feather>
                    </b-button>
                  </div>
                </div>
              </template>
            </BaseTable>
          </div>
        </b-row>
      </b-card>
    </b-col>
    <template>
      <ModalAgregarMarca 
        ref="modalAgregarMarca" 
        @actualizarTabla="actualizarTabla"
      />
    </template>
    <template>
      <ModalEditarMarca 
        ref="modalEditarMarca" 
        :datosMarca="datosMarca" 
        @actualizarTabla="actualizarTabla"
      />
    </template>
    <template>
      <DialogConfirmar 
        ref="dialogConfirmar"
        :mensaje="mensajeDialog"
        @confirmado="actualizarEstatus" 
        @sinConfirmar="restablecerEstatus" 
      />
    </template>
  </b-row>
</template>

<script>
import MarcasDataService from "../../../services/MarcasDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto";

import ModalAgregarMarca from './ModalAgregarMarca.vue';
import ModalEditarMarca from "./ModalEditarMarca.vue";
import BaseTable from "../../components/BaseTable.vue";
import InputBuscar from "../../components/InputBuscar.vue";
import BotonAgregar from "../../components/BotonAgregar.vue";
import DialogConfirmar from "../../components/DialogConfirmar.vue";

import { generalSweetAlert } from "../../../utils/Utils";

export default {
  name: "marcas",
  components: {
    ModalAgregarMarca,
    ModalEditarMarca,
    BaseTable,
    InputBuscar,
    BotonAgregar,
    DialogConfirmar
  },
  data() {
    return {
      marcas: [],
      marca: {
        id: 0,
        nombre: "",
        habilitado: false,
      },
      datosMarca : {},
      marcaSeleccionada: null,
      mensajeDialog: "",
      aceptar: "Aceptar",
      cancelar: "Cancelar",
      title: "",
      filter: "",
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      headers: [
        {
          key: "nombre",
          label: "Marca",
          sortable: true,
        },
        {
          key: "Acciones",
          label: "Acciones",
          class: "largo-columna-acciones",
        },
      ],
      totalRows: 10,
      currentPage: 1,
      perPage: 10,
      filterOn: [],
      key: "",
      iconBoton: "folder",
    };
  },

  mounted() {
    this.key = sessionStorage.getItem('key')
    this.$nextTick(() => {
      this.obtenerMarcas();
    });
  },

  methods: {
    getDisplayMarca(marca) {
      return {
        id: marca.id,
        nombre: marca.marca,
        habilitado: marca.habilitado,
      };
    },

    mostrarModalAgregarMarca(){
      this.$refs.modalAgregarMarca.showModal();
    },

    mostrarModalEditar(datos){
      this.datosMarca = {...datos};

      this.$nextTick(() => {
        this.$refs.modalEditarMarca.showModal();
      })
    },

    async actualizarTabla(){
      await this.obtenerMarcas();
    },

    async obtenerMarcas() {
      try {
        const response = await MarcasDataService.getAll();
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.marcas = decoded.map(this.getDisplayMarca);
        this.totalRows = this.marcas.length;
      } catch (error) {
        console.error("Error al obtener las marcas: ",error)
        generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error')
      }
    },

    mostrarDialog(datos){
      this.marcaSeleccionada = datos
      const habilitarTranslate = datos.habilitado ? this.$t("Gral.des") : this.$t("Gral.h");
      
      this.mensajeDialog = this.$t("vMarca.msgHabilitar", { frase: habilitarTranslate })

      this.$nextTick(() =>{
        this.$refs.dialogConfirmar.openDialog()
      })
    },

    async actualizarEstatus(){
      try {
      if (!this.marcaSeleccionada) return

      const habilitarTranslate = this.marcaSeleccionada.habilitado ? this.$t("Gral.h") : this.$t("Gral.des");
      const habilitarAccion = this.marcaSeleccionada.habilitado ? "h" : "desh";

      const response = await MarcasDataService.delete(this.marcaSeleccionada.id, this.key);

      if (response.status == 200) {
        this.accion = "Ha " + habilitarAccion + "abilitado la marca " + this.marcaSeleccionada.nombre;
        this.registrarAccion();
        await this.obtenerMarcas();
        this.marcaSeleccionada = null

        const mensaje = this.$t("vMarca.msgHabilitarToast", { frase: habilitarTranslate})
        generalSweetAlert(mensaje, 'success')
      }
      } catch (error) {
        console.error("Error al actualizar el estatus de la marca: ",error)
        generalSweetAlert(this.$t('vMarca.msgErrorActualizar', 'error'))
      }
    },

    restablecerEstatus(){
      this.marcaSeleccionada.habilitado = !this.marcaSeleccionada.habilitado
      this.marcaSeleccionada = null
    },
   
    hoverHabilitado(hab) {
      if (hab) return this.$t("Gral.deshabilitar");
      else return this.$t("Gral.habilitar");
    },

    registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems;
      this.currentPage = 1;
    }
  },
};
</script>

<style>
.largo-columna-acciones {
  width: 200px;
}

@media only screen and (max-width: 1600px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media screen and (max-width: 991px) {
  .largo-columna-acciones {
    width: 200px;
  }
}

@media (max-width: 959px) {
 .boton-limpiar, .boton-agregar{
  margin-top: -16px;
 }

 .tabla-marcas{
  margin-top: -8px;
 }
}

@media (min-width: 960px) {
 .boton-limpiar, .boton-agregar{
  margin-top: 0px !important;
 }
}

@media screen and (max-width: 767px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media screen and (max-height: 450px) {
  .largo-columna-acciones {
    width: 100px;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {
  /* Force table to not be like tables anymore */
  .tblmarcas table,
  .tblmarcas thead,
  .tblmarcas tbody,
  .tblmarcas th,
  .tblmarcas td,
  .tblmarcas tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .tblmarcas thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .tblmarcas tr {
    border: 1px solid #ccc;
  }

  .tblmarcas td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 5%;
    text-align: left;
  }

  .tblmarcas td:after {
    /* Now like a table header */
    position: relative;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 70%;
    padding-right: 10px;
    white-space: nowrap;
  }
  /*
	Label the data
	*/
  .tblmarcas td:nth-of-type(1):before {
    content: "Nombre: ";
  }
  .tblmarcas td:nth-of-type(2):before {
    content: "Acciones: ";
  }
}
</style>
